import {isNullOrUndefined} from 'util';
import {Logger} from '../utils/Logger';
import {DOCUMENT} from '@angular/common';
import {Scheduler} from '../utils/Scheduler';
import {HttpClient} from '@angular/common/http';
import {PageMapping} from '../utils/PageMapping';
import {MatDialog} from '@angular/material/dialog';
import {UserService} from '../service/user.service';
import {LoginHelper} from '../helpers/login.helper';
import {UserNavigator} from '../utils/UserNavigator';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, Inject, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {ReferralService} from '../service/referral.service';
import {Keys, StorageService} from '../service/storage.service';
import {LoginInteractor} from '../interactors/login.interactor';
import {EntityConflictError} from '../errors/EntityConflictError';
import {LoanDetailsService} from '../service/loan-details.service';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';
import {LenderDetailsService} from '../service/lender-details.service';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {UnverifiedMobileNumberError} from '../errors/unverified-mobile-number.error';
import { ConfigService } from '../service/config.service';
import { Validator } from '../utils/Validator';

const PHONE_NUMBER_FORMAT = /[6-9][0-9]{9}/;
const PAN_NUMBER_FORMAT = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z])$/;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [ApiServiceService, ReferralService, UserService, PageMapping]
})
export class LoginComponent implements OnInit {
    public otp: string;
    public loginId: string;
    public otpSentText: string;
    public otpError: boolean;
    public finzyDomain = true;
    public otpErrorMsg: string;
    public isReadonly: boolean;
    public otherDomain: boolean;
    public mobileError: boolean;
    public otpDisabled: boolean;
    public showOTPButton = true;
    public mobileErrorMsg: string;
    public otpButton = 'SEND OTP';
    public fieldDisabledTag: boolean;
    public loaderStatus: LoaderStatus = {isLoading: false};
    private sendOTP: boolean;
    private httpClient: HttpClient;
    private apiService: ApiServiceService;
    private dialog: MatDialog;
    private router: Router;
    private scheduler: Scheduler;
    private readonly storageService: StorageService;
    private readonly configService: ConfigService;
    private readonly loginHelper: LoginHelper;
    private readonly loginInteractor: LoginInteractor;
    private readonly loanDetailsService: LoanDetailsService;
    private readonly lenderDetailsService: LenderDetailsService;
    public profile_id: string;

    constructor(private route: ActivatedRoute, dialog: MatDialog, http: HttpClient, apiService: ApiServiceService, router: Router,
                storageService: StorageService, meta: Meta, title: Title, @Inject(DOCUMENT) private document: any, scheduler: Scheduler,
                private pageMapping: PageMapping, private userService: UserService, private userNavigateUtil: UserNavigator,
                private loanApplicationInteractor: LoanApplicationInteractor, loginHelper: LoginHelper, private analyticsTracker: AnalyticsTracker,
                loginInteractor: LoginInteractor, loanDetailsService: LoanDetailsService, lenderDetailsService: LenderDetailsService, configService: ConfigService,
                private readonly validator: Validator) {
        title.setTitle('finzy - Login');
        meta.updateTag({name: 'keywords', content: 'finzy, finzy india, finzy bangalore, peer to peer lending, Login'});
        meta.updateTag({name: 'description', content: 'Login to finzy'});
        this.loginHelper = loginHelper;
        this.dialog = dialog;
        this.router = router;
        this.httpClient = http;
        this.scheduler = scheduler;
        this.apiService = apiService;
        this.storageService = storageService;
        this.loginInteractor = loginInteractor;
        this.loanDetailsService = loanDetailsService;
        this.lenderDetailsService = lenderDetailsService;
        this.configService = configService;
        this.profile_id = this.storageService.getItem(Keys.PROFILE_ID);
    }

    public enableResendOTP = () => {
        this.fieldDisabledTag = false;
        this.showOTPButton = true;
        this.isReadonly = false;
    };

    async ngOnInit() {
        this.dialog.closeAll();
        this.otpError = false;

        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }

        if (this.storageService.getItem(Keys.MOBILE) === 'exists') {
            this.otpError = true;
            this.otpErrorMsg = 'Mobile number already registered please login to continue';
            return;
        }

        if (this.storageService.getItem(Keys.SESSION_OUT) === 'true') {
            this.otpError = true;
            this.otpErrorMsg = 'Your login session has been expired. Please login to continue';
            return;
        }

        await this.userNavigateUtil.redirectUserBasedOnLoggedInStatus();
    }

    public async sendOtp() {
        this.otpSentText = null;
        this.mobileError = false;
        if (this.isValid(this.loginId)) {
            this.isReadonly = true;
            this.fieldDisabledTag = true;
            try {
                const {id, maskedPhoneNumber} = await this.loginInteractor.requestLogIn(this.loginId);
                this.sendOTP = true;
                this.otpButton = 'RESEND OTP';
                this.storageService.saveItem(Keys.LOGIN_TOKEN, id);
                this.showOTPButton = false;
                this.otpSentText = `An OTP has been sent to ${maskedPhoneNumber} and your registered email id.`;
                this.disableResendOTPFor();
            } catch (error) {
                if (error.status === 404) {
                    this.mobileErrorMsg = 'We don\'t have you registered with the Login ID provided. ' +
                        'Please enter a valid Login ID.';
                } else if (error instanceof UnverifiedMobileNumberError) {
                    this.storageService.saveObjectToSession(Keys.LOGIN_ID, this.loginId);
                    await this.navigateToUnverifiedPhoneNumberPage();
                } else if (error.status === 429) {
                    this.mobileErrorMsg = 'You have requested for the verification code too many times. Please wait for some time before trying again.';
                } else if (error instanceof EntityConflictError) {
                    this.mobileErrorMsg = 'Your phone number is registered with multiple accounts. ' +
                        'Please replace the above phone number with the PAN associated with the account and click on Send OTP to proceed.';
                } else {
                    this.mobileErrorMsg = 'Something went wrong. Please try again later.';
                }
                this.fieldDisabledTag = false;
                this.isReadonly = false;
                this.mobileError = true;
                return false;
            }
        }
    }

    async submitOtpLogin(formdata): Promise<void> {
        this.otpError = false;
        if (this.sendOTP === true) {
            if (isNullOrUndefined(formdata.loginId) || isNullOrUndefined(formdata.otp)) {
                this.otpError = true;
                this.otpErrorMsg = 'Please fill out both the fields';
                return;
            } else {
                await executeWithLoader(this.loaderStatus, async () => {
                    try {
                        const user = await this.login(formdata);
                        const [userResponse, loanApplications] = await Promise.all([
                            await this.userService.getUserByProfileId(user._id),
                            await this.loanApplicationInteractor.getByUserId(user._id)
                        ]);

                        if (userResponse.loanDetails) {
                            await this.loginHelper.saveLoanDetails(userResponse.loanDetails);
                        }

                        if (loanApplications.length > 0) {
                            this.storageService.saveObject(Keys.LOAN_APPLICATION, loanApplications[0]);
                            this.storageService.saveItem(Keys.BORROWER, 'true');
                        }

                        if (user.generated_user_id.includes('FINX')) {
                            this.storageService.saveItem(Keys.FINX, 'true');
                        }

                        if (user.generated_user_id) {
                            this.storageService.saveItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE, this.validator.isRestrictUserBasedOnCreatedAt(user.createdAt, this.configService.getRestrictedDate()).toString())
                            this.storageService.saveItem(Keys.GENERATED_USER_ID, user.generated_user_id);
                        }

                        if (userResponse.lenderDetails) {
                            await this.loginHelper.saveLenderDetails(userResponse.lenderDetails);
                        }

                        // TODO - Ashray - Move this to login.interactor
                        this.analyticsTracker.setUserId();
                        this.analyticsTracker.sendAuthenticationEvent();

                        await this.loginHelper.redirectUser(userResponse.loanDetails, userResponse.lenderDetails, loanApplications, user);
                    } catch (error) {
                        if (error.status === 401) {
                            this.otpError = true;
                            this.otpErrorMsg = 'Please provide a valid OTP';
                        } else if (error.status === 429) {
                            this.otpError = true;
                            this.otpErrorMsg = 'Please generate another OTP and try again';
                        } else {
                            Logger.error(`Error while logging in: ${error}`);
                        }
                    }
                });
            }
        } else {
            this.otpError = true;
            this.otpErrorMsg = 'Please click on send OTP to continue';
            return;
        }
    }

    private async login(formdata): Promise<any> {
        const password = formdata.otp;
        const loginRequestId = this.storageService.getItem(Keys.LOGIN_TOKEN);
        return this.loginInteractor.verifyPassword(loginRequestId, password);
    }

    private disableResendOTPFor() {
        this.scheduler.scheduleCallback(1000 * 30, this.enableResendOTP);
    }

    private isValid(loginId: string) {
        if (PHONE_NUMBER_FORMAT.test(loginId) || PAN_NUMBER_FORMAT.test(loginId)) {
            return true;
        } else {
            this.mobileError = true;
            this.mobileErrorMsg = 'Please provide valid login information.';
            return false;
        }
    }
    private async navigateToUnverifiedPhoneNumberPage(): Promise<void> {
        await this.router.navigate(['/borrow/phone-number/verification']);
    }
}
